import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEconomicAccountData(companyId: number) {
    const { data: accounts, isLoading: isLoadingAccounts } = useQuery({
        queryKey: ['economic-accounts', companyId],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.bank.company-accounts'));
            return data;
        },
        placeholderData: [],
    });

    return {
        accounts,
        isLoadingAccounts,
    };
}
